import { makeCampaignTargetProviderDef } from "@flow/common/campaign_target_provider";
import { ConfigTypeSerializer, MembershipListConfigTypeSerializer } from "./types";

export const mpdbListTarget = makeCampaignTargetProviderDef({
  provider_unique_id: "mpdatabase:mpdb_list_target",
  label: "MP Database List",
  config_type: ConfigTypeSerializer,
});

export const mpdbMultipleTarget = makeCampaignTargetProviderDef({
  provider_unique_id: "mpdatabase:mpdb_multiple_target",
  label: "MP Database Member Lookup",
  config_type: MembershipListConfigTypeSerializer,
});
